import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import * as _ from 'lodash';
import { FileInfo } from '@progress/kendo-angular-upload';
import { PhotoBus } from '../models/PhotoBus';

@Injectable()
export class MediaService extends BaseService {

    constructor(_http: HttpClient) {
        super(_http);
        this.baseUrl = this.rootUrl + "media/";
    }
    
    upload(files: FileInfo[]): Observable<any> {
        var headers = new HttpHeaders().set('Content-Type', undefined)
            .set('Accept', undefined)
            .set("key-1", "value-1")
            .set("key-2", "value-2");

        const formData = new FormData();

        for (const file of files) {
            formData.append(file.name, file.rawFile);
        }
        formData.append("key-1", "value-1");
        formData.append("key-2", "value-2");
        let url_call: string = this.baseUrl + "upload";
        return this._http.post(url_call, formData, { headers });
    }

    deletePhotos(type: string, id: string): Observable<any> {
        let url_call: string = this.baseUrl + "DeletePhoto/" + type + "/" + id;
        return super.get(url_call);
    }

    getImageWithAuth(photoUrl: string): Observable<Blob> {
        const headers = this.getHeaders();
        return this._http.get(photoUrl, {
            headers: headers,
            responseType: 'blob'
        });
    }

    uploadPhoto(files: FileInfo[], attachmentName: string, photo: PhotoBus, type: string): Observable<any> {
        const url: string = this.baseUrl + "UploadItemPhoto";
        const formData = new FormData();

        for (const file of files) {
            formData.append('files', file.rawFile, file.name);
        }

        const attachmentData = {
            attachmentName: attachmentName,
            parentId: photo.parentId,
            photoId: photo.photoId,
            photoCategoryId: photo.photoCategoryId,
            imageName: photo.imageName,
            fileName: photo.fileName,
            description: photo.description,
            type: type,
            visibleToCustomers: photo.visibleToCustomers,
            sequenceNumber: photo.sequenceNumber || ''
        };

        formData.append("AttachmentData", JSON.stringify(attachmentData));

        return this._http.put(url, formData);
    }
}